import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.number.constructor";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Watch } from 'vue-property-decorator';
import { showErrors, showNotification } from '@/utils/snack';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import { findDealer } from '@/views/DealerList/gql';
import AppDialog from '@/components/AppDialog.vue';
import AppTextField from '@/components/AppTextField.vue';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import { removeGoodsFromDealer, updateDisplayOrder } from '../gql';
import { SnackType } from '@/interfaces/snack';
import draggable from 'vuedraggable';
import AuthFilter from '@/mixins/auth-filter';
import { mixins } from 'vue-class-component';
import DealerOrders from '../script-orders';

var EditDealerGoods = /*#__PURE__*/function (_mixins) {
  _inherits(EditDealerGoods, _mixins);

  var _super = _createSuper(EditDealerGoods);

  function EditDealerGoods() {
    var _this;

    _classCallCheck(this, EditDealerGoods);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [];
    _this.dealerId = '';
    _this.dealerName = '';
    _this.allGoods = null;
    _this.selectedGoods = null;
    _this.goods = [];
    _this.displayGoods = [];
    _this.displayOrders = [];
    _this.disabledActions = true;
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.actionsHeight = 51;
    return _this;
  }

  _createClass(EditDealerGoods, [{
    key: "displayOrdersChange",
    value: function displayOrdersChange(val) {
      var _this2 = this;

      if (val.length !== 0) {
        var arr = [];

        if (this.goods) {
          this.displayOrders.forEach(function (item) {
            var _this2$goods;

            var goods = (_this2$goods = _this2.goods) === null || _this2$goods === void 0 ? void 0 : _this2$goods.find(function (g) {
              return item === g.goodId;
            });
            arr.push(goods);
          });
        }

        this.displayGoods = arr;
      }
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = this.$route.params.id;
                this.dealerId = id;
                _context.next = 4;
                return this.getDealerById(Number(this.dealerId));

              case 4:
                _context.next = 6;
                return this.getGoodsOrders();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "getDealerById",
    value: function () {
      var _getDealerById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dealerId) {
        var result, dealer, typedError;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$apollo.query({
                  query: findDealer,
                  variables: {
                    dealerId: dealerId
                  }
                });

              case 3:
                result = _context2.sent;

                if (result) {
                  dealer = result.data.findDealer;
                  this.goods = dealer === null || dealer === void 0 ? void 0 : dealer.goodRelations;
                  this.dealerId = (dealer === null || dealer === void 0 ? void 0 : dealer.id) + '';
                  this.dealerName = (dealer === null || dealer === void 0 ? void 0 : dealer.realname) + '';
                  this.breadcrumbs = [{
                    text: '经销商管理'
                  }, {
                    text: '经销商',
                    to: {
                      name: 'DealerList'
                    }
                  }, {
                    text: "".concat(this.dealerName),
                    to: {
                      name: 'DealerDetail',
                      params: {
                        id: "".concat(this.dealerId)
                      }
                    }
                  }, {
                    text: '小店商品'
                  }];
                }

                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getDealerById(_x) {
        return _getDealerById.apply(this, arguments);
      }

      return getDealerById;
    }()
  }, {
    key: "updateGoodsOrders",
    value: function () {
      var _updateGoodsOrders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this$displayGoods;

        var orders, result, typedError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                orders = (_this$displayGoods = this.displayGoods) === null || _this$displayGoods === void 0 ? void 0 : _this$displayGoods.map(function (item) {
                  return item.goodId;
                });
                _context3.prev = 1;
                _context3.next = 4;
                return this.$apollo.mutate({
                  mutation: updateDisplayOrder,
                  variables: {
                    dealerId: +this.dealerId,
                    orders: orders
                  }
                });

              case 4:
                result = _context3.sent;

                if (result) {
                  showNotification({
                    msg: '保存成功',
                    type: SnackType.Info
                  });
                  this.disabledActions = true;
                  this.$router.go(-1);
                }

                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 8]]);
      }));

      function updateGoodsOrders() {
        return _updateGoodsOrders.apply(this, arguments);
      }

      return updateGoodsOrders;
    }()
  }, {
    key: "deleteGoods",
    value: function () {
      var _deleteGoods = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(item) {
        var goodIds, result, typedError;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                goodIds = [];
                goodIds.push(item.id);
                _context4.prev = 2;
                _context4.next = 5;
                return this.$apollo.mutate({
                  mutation: removeGoodsFromDealer,
                  variables: {
                    dealerId: +this.dealerId,
                    goodIds: goodIds
                  }
                });

              case 5:
                result = _context4.sent;

                if (!result) {
                  _context4.next = 12;
                  break;
                }

                showNotification({
                  msg: '删除成功',
                  type: SnackType.Info
                });
                _context4.next = 10;
                return this.getDealerById(Number(this.dealerId));

              case 10:
                _context4.next = 12;
                return this.getGoodsOrders();

              case 12:
                _context4.next = 18;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](2);
                typedError = _context4.t0;
                showErrors(typedError.graphQLErrors);

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 14]]);
      }));

      function deleteGoods(_x2) {
        return _deleteGoods.apply(this, arguments);
      }

      return deleteGoods;
    }()
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      var actionDom = this.$refs.actions;
      this.actionsHeight = actionDom.clientHeight;
    }
  }, {
    key: "beforeRouteLeave",
    value: function () {
      var _beforeRouteLeave = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(to, from, next) {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.disabledActions) {
                  res = confirm('页面修改尚未保存，是否确定要离开？');
                  next(res);
                } else {
                  next();
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function beforeRouteLeave(_x3, _x4, _x5) {
        return _beforeRouteLeave.apply(this, arguments);
      }

      return beforeRouteLeave;
    }()
  }, {
    key: "filterGoods",
    get: function get() {
      var _this$allGoods,
          _this3 = this;

      if (((_this$allGoods = this.allGoods) === null || _this$allGoods === void 0 ? void 0 : _this$allGoods.length) !== 0) {
        var _this$allGoods2;

        return (_this$allGoods2 = this.allGoods) === null || _this$allGoods2 === void 0 ? void 0 : _this$allGoods2.filter(function (item) {
          var _this3$goods;

          return !((_this3$goods = _this3.goods) === null || _this3$goods === void 0 ? void 0 : _this3$goods.some(function (ele) {
            return ele.goodId === item.id;
          }));
        });
      } else {
        return [];
      }
    }
  }]);

  return EditDealerGoods;
}(mixins(AuthFilter, DealerOrders));

__decorate([Watch('displayOrders', {
  deep: true,
  immediate: true
})], EditDealerGoods.prototype, "displayOrdersChange", null);

EditDealerGoods = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppDialog: AppDialog,
    AppTextField: AppTextField,
    AppSearchBtn: AppSearchBtn,
    draggable: draggable
  }
})], EditDealerGoods);
export default EditDealerGoods;